module.exports = "/assets/data/621fed47c9a6417292ece5b1ecfbcb03-B44.data.json";